import { render, staticRenderFns } from "./concepts-modal-basic-form.vue?vue&type=template&id=af732478&scoped=true&"
import script from "./concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./concepts-modal-basic-form.scss?vue&type=style&index=0&id=af732478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af732478",
  null
  
)

export default component.exports